module.exports = __webpack_public_path__ + "media/images/covid/travelingTeaser-fa186649eb3f822f39bf45cbdddb9bd8.jpg";